import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-hometwo-funfacts',
    templateUrl: './hometwo-funfacts.component.html',
    styleUrls: ['./hometwo-funfacts.component.scss']
})
export class HometwoFunfactsComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    singleFunfactsBox: Funfacts[] = [
        {
            icon: "assets/img/funfacts/icon1.png",
            title: '20 jaar',
            subTitle: 'Ervaring'
        },
        {
            icon: "assets/img/funfacts/icon2.png",
            title: '100%',
            subTitle: 'Persoonlijke aanpak'
        },
        {
            icon: "assets/img/funfacts/icon3.png",
            title: '100%',
            subTitle: 'Transparantie'
        },

    ]

}
class Funfacts {
    icon : string;
    title : string;
    subTitle : string;
}
